/**
 * promo-popup.js — Popup promo "Lancement saison 2026"
 * Affiché une seule fois par visiteur (localStorage), uniquement avant la deadline.
 * Aucun texte hardcodé ici : tous les libellés visibles vivent dans la section .liquid (bilingue).
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'omyboat_promo_lancement_2026_seen';
  // La promo expire le 30 juin 2026 inclus -> ne plus afficher à partir du 1er juillet 2026.
  var DEADLINE = new Date('2026-07-01T00:00:00');
  var SHOW_DELAY_MS = 1200;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    var popup = document.getElementById('omyboat-promo-popup');
    if (!popup) return;

    // 1. Deadline dépassée -> on n'affiche jamais.
    if (new Date() >= DEADLINE) return;

    // 2. Déjà vu par ce visiteur -> on n'affiche pas.
    try {
      if (window.localStorage && localStorage.getItem(STORAGE_KEY)) return;
    } catch (e) { /* localStorage indispo (mode privé) : on affiche quand même */ }

    var backdrop = popup;
    var dialog = popup.querySelector('.promo-popup__dialog');
    var closeEls = popup.querySelectorAll('[data-promo-close]');

    function markSeen() {
      try {
        if (window.localStorage) localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) { /* no-op */ }
    }

    function open() {
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      markSeen(); // une fois affiché, ne réapparaît plus
    }

    function close() {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    // Fermeture : croix, bouton, clic en dehors du dialog
    Array.prototype.forEach.call(closeEls, function (el) {
      el.addEventListener('click', close);
    });
    backdrop.addEventListener('click', function (e) {
      if (dialog && !dialog.contains(e.target)) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-open')) close();
    });

    window.setTimeout(open, SHOW_DELAY_MS);
  });
})();
